import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock } from "vue"

import { ref } from 'vue';
import { NavigationButton } from './types';

interface Props {
  data: NavigationButton;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'NavigationButton',
  props: {
    data: null
  },
  setup(__props: any) {

const props = __props as {
  data: NavigationButton;
}



const loading = ref<boolean>(false);
function clickHandler() {
  const action = props.data.action;
  const promise = action();
  if (promise instanceof Promise){
    loading.value = true;
    promise.finally(() => {
      loading.value = false;
    });
  }
}

return (_ctx: any,_cache: any) => {
  const _component_FontAwesomeIcon = _resolveComponent("FontAwesomeIcon")!

  return (_openBlock(), _createElementBlock("button", {
    class: _normalizeClass(["navigation-button", {loading: loading.value}]),
    onClick: clickHandler
  }, [
    (__props.data.icon)
      ? (_openBlock(), _createBlock(_component_FontAwesomeIcon, {
          key: 0,
          class: "mr-1",
          icon: __props.data.icon
        }, null, 8, ["icon"]))
      : _createCommentVNode("", true),
    _createElementVNode("span", null, _toDisplayString(__props.data.label), 1)
  ], 2))
}
}

})